import React from "react";
import { Form, FormControl, Button } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";

const SearchBar = ({ props }) => {
  const data = props;
  //form
  const [inputValue, setInputValue] = useState("");
  //search data
  const onSearch = (searchedProduct) => {
    setInputValue(searchedProduct);
  };
  const handleSubmit = (e)=>{
    e.preventDefault()
  }

  return (
    <>
      <Form onSubmit={handleSubmit} className="d-flex justify-content-center align-items-center mt-5 mx-auto max-width-800 searchbar">
        <FormControl
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
          type="text"
          placeholder="Search for a recipe"
          className="mr-auto"
        />
        <Button variant="primary">Search</Button>
        <div className="dropdown">
          {data
            .filter((item) => {
              const searchTerm = inputValue.toLocaleLowerCase();
              const product = item.title.toLocaleLowerCase();
              // if searchTerm exists and it includes the value return something, otherwise return nothing
              if (searchTerm && product.includes(searchTerm)) {
                return searchTerm; // returns an [object] with all matching results
              }
            })
            .map(
              (
                item,
                index // loop through the [object] and render each results on screen
              ) => (
                <Link
                  to={"/recipeDetails/" + item._id}
                  onClick={() => onSearch(item.title)}
                  key={index}
                  className="dropdown-row"
                >
                  <img src={item.image.url} alt="" />
                  {item.title}
                </Link>
              )
            )}
        </div>
      </Form>
    </>
  );
};

export default SearchBar;
